/**
 * @list {Array} 轮播的数组
 * @start {Number} 从第几张图片开始下标
 * @offset {Number} 偏移量
 * @scale {Number} 缩放差值
 * @auto {Boolean} 是否自动轮播
 * */
export default class Turn {
  constructor({
    list, start = 0, offset = 0.2, scale = offset, auto = true,
  }) {
    this.list = list;
    this.auto = auto;
    this.offset = offset;
    this.scale = scale;
    this.start = start;
  }

  init() {
    const {
      list,
      auto,
      start,
    } = this;
    this.move(start);
    if (auto) this.autoMove();
    return list;
  }

  move(selectedIdx) {
    const {
      list,
      offset,
      scale,
    } = this;
    const { length } = list;
    const max = Math.ceil(length / 2);
    const middle = max - 1;
    list.forEach((item, index) => {
      const space = selectedIdx - index;
      if (space === 0) {
        item.order = 0;
      }
      if (space <= middle || (space < 0 && -space <= middle)) {
        item.order = index - selectedIdx;
      }
      if (space > middle) {
        item.order = max - (selectedIdx - index - middle);
      }
      if (space < 0 && -space > middle) {
        item.order = index - selectedIdx - length;
      }
      item.x = item.order * offset;
      item.scale = 1 - Math.abs(item.order) * scale;
      item.zIndex = max - Math.abs(item.order);
    });
  }

  autoMove() {
    this.auto = setInterval(() => {
      const { list } = this;
      const { length } = list;
      const index = list.findIndex(v => v.show);
      let newIdx = index + 1;
      if (length === newIdx) newIdx = 0;
      this.move(newIdx);
    }, 3000);
  }

  stopMove() {
    clearInterval(this.auto);
    this.auto = null;
  }

  click(index) {
    const { list, auto } = this;
    const oldIndex = list.findIndex(v => v.show);
    if (auto) {
      clearInterval(auto);
      this.auto = null;
    }
    if (index < oldIndex) {
      return -1;
    }
    return 1;
  }
}
